import isPodcastEpisode from './isPodcastEpisode';
export default isPodcastEpisode;
